module.exports = __webpack_public_path__ + "9c73c2bb80c28dea99ab09d3bcaeb94e.pdf";